import React, {useEffect} from "react"
import { graphql } from "gatsby"
import { Helmet } from 'react-helmet';

import { Layout } from "@components/Layout";
import SingleProductPage from "@contents/parts/SingleProductPage";
import ReviewsPanel from "@components/ReviewsPanel/ReviewsPanel";
import { GA_EVENTS } from "@utils/analytics/constants";

const SingleProduct = ({ data }) => {
    const shuffleArray = (array) => {
        return array.sort(() => Math.random() - 0.5);
    }

    const product = data?.shopifyProduct;
    const recommendedProducts = shuffleArray(data?.recommendedProducts?.nodes).slice(0, 10);
    const seoTitle = product?.seo?.title;
    const seoDescription = product?.seo?.description;
    const productImage = product?.featuredImage?.src;

    const saveRecentlyViewedProduct = (product) => {
        // Retrieve the current list from localStorage
        let recentlyViewed = [];
        
        if (typeof window !== 'undefined') {
            recentlyViewed = JSON.parse(localStorage?.getItem("recentlyViewed")) || [];
        }
    
        // Check if the product ID already exists in the list
        const productExists = recentlyViewed.some((item) => item.handle === product.handle);
    
        // If product does not exist, add it to the beginning of the array
        if (!productExists) {
            recentlyViewed.unshift(product);
    
            // Limit to the latest 10 products
            if (recentlyViewed.length > 10) {
                recentlyViewed = recentlyViewed.slice(0, 10);
            }

            if (typeof window !== 'undefined') {
                // Save the updated list back to localStorage
                localStorage.setItem("recentlyViewed", JSON.stringify(recentlyViewed));
            }
        }
    };

    useEffect(() => {
        if (product) {
            saveRecentlyViewedProduct(product);
        }
    }, [product]);

    
    
    return (
        <Layout 
			gaEvent={{
				eventName: GA_EVENTS.VIEW_ITEM, 
				params: {
					value: product?.priceRangeV2?.minVariantPrice?.amount,
					page_path: `/products/${product?.handle}`,
					page_title: `${seoTitle}`,
					item_name: product?.title,
      				item_brand: "Blackbough Swim",
					queryName: 'view product page',
				},
			}}
		>
            <Helmet>
                <title>{seoTitle}</title>
                <meta name="description" content={seoDescription} />
                <meta property="og:image" content={productImage} />
            </Helmet>
            
            <SingleProductPage product={product} recommendedProducts={recommendedProducts} />
        </Layout>
    )
};

export const query = graphql`
  query ProductQuery($handle: String!, $relatedTags: [String!]) {
    shopifyProduct(handle: { eq: $handle }) {
      shopifyId
      title
      handle
      description
      descriptionHtml
      featuredImage {
        src
      }
      collections {
        handle
      }  
      media {
        preview {
          image {
            src
            gatsbyImageData
          }
        }
      }
      priceRangeV2 {
        minVariantPrice {
          amount
        }
      }
      tags
      metafields {
        id
        key
        value
      }
      seo {
        title
        description
      }
      variants {
        id
        storefrontId
        title
        position
        availableForSale
        inventoryQuantity
        compareAtPrice
      }
    }
    recommendedProducts: allShopifyProduct(
      filter: { tags: { in: $relatedTags }, handle: { ne: $handle } }
      limit: 20
    ) {
      nodes {
        title
        handle
        media {
          preview {
            image {
              src
              gatsbyImageData
            }
          }
        }
        priceRangeV2 {
          minVariantPrice {
            amount
          }
        }
        variants {
          id
          storefrontId
          title
          position
          availableForSale
          inventoryQuantity
          compareAtPrice
        }
      }
    }
  }
`;

export default SingleProduct;